import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { UIRouter, UrlService } from '@uirouter/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { OauthService } from '@monsido/oauth/oauth.service';
import { SessionStorageService } from '@monsido/angular-shared-components';
import { BaseChart } from './app/modules/charts/models/chart';
import { ThemeService } from '@client/app/services/theme.service';

// Un-comment to debug UI-Router
// import { trace } from '@uirouter/angular'; // or "angular-ui-router"
// trace.enable(0, 1, 2, 3, 4); // TRANSITION and VIEWCONFIG

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        preserveWhitespaces: true,
        ngZone: 'zone.js',
    })
    .then(async (platformRef) => {
        const urlService: UrlService = platformRef.injector.get(UIRouter).urlService;
        const oauthService = platformRef.injector.get(OauthService);
        const themeService = platformRef.injector.get(ThemeService);

        themeService.init();
        const sessionStorageService = platformRef.injector.get(SessionStorageService);

        // Instruct UIRouter to listen to URL changes
        function startUIRouter (): void {
            urlService.listen();
            const searchParams = urlService.search();
            oauthService
                .processStateParam(searchParams.state)
                .onSuccess(async () => {
                    if (searchParams.sudo && searchParams.code) {
                        oauthService.cancelScheduledRefresh();
                        sessionStorageService.removeItem('oauth');
                        sessionStorageService.removeItem('monStateLocationCode');
                    } else {
                        try {
                            await oauthService.scheduleRefreshAccessToken();
                        } catch (e) {}
                    }
                    urlService.sync();
                });
        }

        platformRef.injector.get<NgZone>(NgZone).run(startUIRouter);

        BaseChart.setupListeners();
        window.addEventListener('beforeunload', (): void => {
            BaseChart.teardownListeners();
        });

    })
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));
